// src/v3/ui/table-presets/pinbar-presets.ts

import type { SmartTablePreset } from "../_deps";
import { APPROVE_STATUS_OBJ, pinbarDefaultPreset } from "../_deps";

export const pinbarPresets: SmartTablePreset[] = [
  pinbarDefaultPreset,
  {
    id: "recent",
    name: "Recent",
    columns: ["symbol", "type", "date", "approveStatus"],
    filters: [],
    sort: [{ column: "date", direction: "desc" }],
    pageSize: 50,
  },
  {
    id: "pending",
    name: "Pending Review",
    columns: ["symbol", "type", "date", "pinbarStatus", "approveStatus"],
    filters: [
      { column: "approveStatus", type: "select-single", value: APPROVE_STATUS_OBJ.NEW },
    ],
    sort: [{ column: "date", direction: "desc" }],
    pageSize: 50,
  },
  {
    id: "shortlist",
    name: "Shortlist",
    columns: ["symbol", "type", "date", "pinbarStatus", "approveStatus"],
    filters: [
      { column: "approveStatus", type: "select-single", value: APPROVE_STATUS_OBJ.TO_SHORTLIST },
    ],
    sort: [{ column: "date", direction: "desc" }],
    pageSize: 50,
  },
  {
    id: "ai-approved",
    name: "AI Approved",
    columns: ["symbol", "type", "date", "pinbarStatus", "approveStatus"],
    filters: [
      { column: "approveStatus", type: "select-single", value: APPROVE_STATUS_OBJ.APPROVED_BY_AI },
    ],
    sort: [{ column: "date", direction: "desc" }],
    pageSize: 50,
  },
];
